module.exports = "<div class=sortable-list> <div class=row> <div class=col-xs-12> <ng-transclude></ng-transclude> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/sortable/list_partial.html
// module id = 559
// module chunks = 0